import { useDispatch, useSelector } from "react-redux";
import { updateAMIAction } from "../../redux/actions/currenciesActions";
import {
    approachesList,
    interestsTypeList,
    methodsList,
    methodsListOverflow
} from "../../staticData/strategies";
import FieldSet from "../common-components/Fieldset";
import SelectInput from "../common-components/SelectInput";

const TradeApproach = () => {
    const { currentCurrencyId, currenciesList, isDarkMode } = useSelector(
        (state) => {
            return state.persistedReducer;
        },
        (oldValue, newValue) => {
            const {
                approach: oldSelectedApproach,
                tradeMethod: oldTradeMethod,
                interestType: oldInterestType,
                operations: { isBinanceOn: oldIsBinanceOn }
            } = oldValue.currenciesList[oldValue.currentCurrencyId];
            const {
                approach: newSelectedApproach,
                tradeMethod: newTradeMethod,
                interestType: newInterestType,
                operations: { isBinanceOn: newIsBinanceOn }
            } = newValue.currenciesList[newValue.currentCurrencyId];
            if (
                oldValue.isDarkMode !== newValue.isDarkMode ||
                oldSelectedApproach?.approachId !== newSelectedApproach?.approachId ||
                oldTradeMethod?.methodId !== newTradeMethod.methodId ||
                oldIsBinanceOn !== newIsBinanceOn ||
                oldValue.currentCurrencyId !== newValue.currentCurrencyId ||
                oldInterestType !== newInterestType
            ) {
                return false;
            }
            return true;
        }
    );
    const {
        approach: selectedApproach,
        tradeMethod,
        interestType,
        operations: { isModelOn }
    } = currenciesList[currentCurrencyId];
    const dispatch = useDispatch();
    const currentMethodList = methodsList[selectedApproach?.approachId];
    const TradeSelectInputs = [
        {
            selectFunction: (value) => {
                if (value?.approachId != selectedApproach?.approachId) {
                    dispatch(
                        updateAMIAction({
                            AMIData: value,
                            key: "approach",
                            valueObject: {
                                buy_approach: value.approachId
                            }
                        })
                    );
                }
            },
            defaultText: selectedApproach?.approachId
                ? approachesList[selectedApproach?.approachId]?.approachName
                : !selectedApproach?.approachId
                ? "Approach"
                : "Loading...",
            options: Object.values(approachesList),
            optionName: "approachName"
        },
        {
            selectFunction: (value) => {
                if (value?.methodId != tradeMethod?.methodId) {
                    dispatch(
                        updateAMIAction({
                            AMIData: value,
                            key: "tradeMethod",
                            valueObject: {
                                method: value.methodId
                            }
                        })
                    );
                }
            },
            defaultText: tradeMethod?.methodId
                ? currentMethodList[tradeMethod?.methodId]?.methodName
                : !tradeMethod?.methodId
                ? "Method"
                : "Loading...",
            options: Object.values(currentMethodList),
            optionName: "methodName"
        },
        {
            selectFunction: (value) => {
                if (value?.interestId != interestType?.interestId) {
                    dispatch(
                        updateAMIAction({
                            AMIData: value,
                            key: "interestType",
                            valueObject: {
                                interest_type: value.interestId
                            }
                        })
                    );
                }
            },
            defaultText:
                typeof interestType?.interestId == "number"
                    ? interestsTypeList[interestType?.interestId]?.interestType
                    : "Interest Type",
            options: Object.values(interestsTypeList),
            optionName: "interestType"
        }
    ];
    return (
        <div>
            <FieldSet
                legend={"Approach | Method | Interest"}
                classNames={{
                    legendClassName: "block p-1  text-sm",
                    fieldsetClassName: "flex w-full items-center primaryBorder rounded-sm "
                }}
                styles={{
                    legendStyle: {},
                    fieldsetStyle: {}
                }}>
                <div className="flex  flex-col w-full justify-around items-center text-vsm ">
                    {TradeSelectInputs.map((input, index) => {
                        const { defaultText, options, selectFunction, optionName } = input;
                        return (
                            <SelectInput
                                key={index}
                                selectFunction={selectFunction}
                                selectHolder={{
                                    // styles: {},
                                    className: "flex-1 flex min-h-7  py-3  rounded-lg  "
                                }}
                                selectOptions={{
                                    holderStyle: {},
                                    className: "flex justify-center relative ",
                                    selectedValue: {
                                        defaultText: defaultText,
                                        style: { zIndex: 0 },
                                        className: `${
                                            isDarkMode
                                                ? "bg-secondaryDark  border-1"
                                                : "bg-secondaryLight "
                                        } min-w-17 min-h-7   flex justify-center items-center cursor-pointer text-vsm md:min-h-9 md:min-w-21 ${
                                            isModelOn ? "opacity-50" : "opacity-100"
                                        }`
                                    },
                                    list: {
                                        holderStyle: {},
                                        className: `absolute top-8 z-80 mt-4 `,
                                        options: options,
                                        singleOption: {
                                            divStyle: {
                                                zIndex: 10
                                            },
                                            divClassName: `${
                                                isDarkMode
                                                    ? "bg-secondaryDark border-1"
                                                    : "bg-tertiaryLight"
                                            }  min-w-17 min-h-7  mt-1 primaryBoxShadow flex items-center justify-center cursor-pointer md:min-h-9 md:min-w-21 `,
                                            labelStyle: {
                                                cursor: "pointer",
                                                fontSize: 10,
                                                zIndex: 10,
                                                backgroundColor: isDarkMode ? "#8D99AE" : "#fff"
                                            },
                                            labelClassName:
                                                "primaryBoxShadow  bg-black flex items-center justify-center cursor-pointer md:min-h-9 md:min-w-21",
                                            inputStyle: {
                                                display: "none"
                                            }
                                        }
                                    }
                                }}
                                optionName={optionName}
                                isEditable={isModelOn ? false : true}
                            />
                        );
                    })}
                </div>
            </FieldSet>
        </div>
    );
};

export default TradeApproach;
